<script lang="ts" setup>
defineProps({
  banners: {
    type: Array,
    required: true,
  },
  indexCatalog: {
    type: String,
    required: true,
  },
});
const emit = defineEmits(['closeCatalog']);
const { $ymGoalEventPromo } = useNuxtApp();
const sendYa = (url: string) => {
  $ymGoalEventPromo('presetMain', url);
};
</script>
<template>
  <div class="banners">
    <nuxt-link
      v-for="(banner, index) in banners"
      :key="index"
      :to="`${banner.url}`"
      class="banners-link"
      @click="
        sendYa(banner.url);
        emit('closeCatalog');
      "
    >
      <picture class="banners-img">
        <source :srcset="banner.image_webp" type="image/webp" />
        <source :srcset="banner.image" type="image/jpeg" />
        <img :src="banner.image" :alt="banner.title" />
      </picture>
    </nuxt-link>
  </div>
</template>
<style lang="scss" scoped>
.banners {
  display: grid;
  grid-gap: 12px;
  justify-content: stretch;
  margin: 16px 0 12px;
  @include md-block {
    grid-template-columns: 1fr 1fr;
    grid-gap: 8px;
    margin-bottom: 8px;
  }

  @include xl-block {
    grid-template-columns: 1fr;
    width: 100%;
    padding: 0;
    grid-gap: 16px;
    margin: 0 0 16px;
  }

  @include xxl-block {
    grid-gap: 20px;
    margin-bottom: 20px;
  }

  .banners-link {
    background-color: #f2f2f2;
    height: 72px;
    box-sizing: border-box;
    border-radius: 4px;
    margin-bottom: 0;
    text-decoration: none;
    color: #242424;
    display: grid;
    align-items: center;
    justify-content: center;

    @include xxl-block {
      height: 96px;
    }

    &:hover,
    &:active,
    &:visited,
    &:focus {
      color: $achromatic-black;
    }

    .banners-img {
      img {
        width: auto;
        height: 72px;
      }
    }
  }
}
</style>
